import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface Props {
	step: number;
	handleNext: () => void;
	handleCreatePlanClick: () => Promise<boolean | undefined>;
}

const FinalStepButton: React.FC<Props> = ({ step, handleNext, handleCreatePlanClick }) => {
	const [openConfirm, setOpenConfirm] = useState(false);

	const handleOpenConfirm = () => setOpenConfirm(true);
	const handleCloseConfirm = () => setOpenConfirm(false);

	const handleConfirm = async () => {
		setOpenConfirm(false);

		// console.log("Step value:", step);
		const result = await handleCreatePlanClick();
		// console.log("Result from handleCreatePlanClick:", result);
		if (!result) {
			return;
		}
		handleNext();
	};

	return (
		<>
			{step === 6 && (
				<>
					<Button
						variant="contained"
						color="success"
						size="small"
						onClick={handleOpenConfirm}
						sx={{ width: { xs: "100%", sm: 125 }, height: 35 }}
					>
						Generate Excel
					</Button>

					<Dialog
						open={openConfirm}
						onClose={handleCloseConfirm}
						aria-labelledby="confirm-dialog-title"
						aria-describedby="confirm-dialog-description"
					>
						<DialogTitle id="confirm-dialog-title">Confirm Plan Creation</DialogTitle>
						<DialogContent>
							<DialogContentText id="confirm-dialog-description">
								Once you proceed, the plan will be created and you won’t be able to go back or modify
								any of the previous details.
								<br />
								<br />
								Do you want to continue?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleCloseConfirm} color="error" variant="outlined">
								Cancel
							</Button>
							<Button onClick={handleConfirm} color="success" variant="contained" autoFocus>
								Yes, Proceed
							</Button>
						</DialogActions>
					</Dialog>
				</>
			)}
		</>
	);
};

export default FinalStepButton;
